import { z, ZodObject, ZodRawShape } from "zod";
import { useTranslation } from "react-i18next";
import { ColumnDef } from "@tanstack/react-table";

export const UserTableColumns: ColumnDef<z.infer<ZodObject<ZodRawShape>>>[] = [
  {
    id: "username",
    accessorKey: "username",
    header: "Name",
    cell: ({ row }) => {
      return row?.original.name ?? row?.original.username;
    },
  },
  {
    id: "email",
    accessorKey: "email",
    header: "Email",
  },
  {
    id: "roles.name",
    accessorKey: "roles.name",
    header: "Roles",
    cell: ({ row }) => {
      const { t } = useTranslation("common");

      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      return row?.original.roles
        ?.map((role: { name: string }) => t("user.role." + role.name))
        .join(", ");
    },
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => {
      const { t } = useTranslation("common");

      if (row.original.status) {
        return t("Active");
      }

      return t("Inactive");
    },
  },
];
